Em.Handlebars.helper 'billingOperationSum', (billingOperation) ->
  res = billingOperation.get('sum') + ""
  if billingOperation.get('type') == "payment"
    res = "+ " + res
  if billingOperation.get('type') == "invoice"
    res = "- " + res
  res

Em.Handlebars.helper 'invoiceItemsString', (invoice) ->
  invoice.get('invoice_items').map((i)-> i.get('description')).join(";")